import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "appointment-title",
      class: {
        "appointment-title_mobile": _setup.isMobile,
      },
    },
    [
      _c(
        "h1",
        {
          staticClass: "text--text",
          class: _setup.isMobile ? "text-h6" : "text-h5",
          attrs: { "data-qa": "appointment_doctor_title" },
        },
        [
          _setup.appointmentDataStore.appointmentPlaceTypes.isHome
            ? [
                _vm._v(
                  "\n      " +
                    _vm._s(_setup.t("Вызвать врача на дом", _setup.options)) +
                    "\n    "
                ),
              ]
            : _setup.appointmentDataStore.appointmentPlaceTypes.isTelemed ||
              _setup.appointmentDataStore.appointmentPlaceTypes
                .isTelemedMedtochka
            ? [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _setup.t("Запись на онлайн-консультацию", _setup.options)
                    ) +
                    "\n    "
                ),
              ]
            : [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _setup.isMobile
                        ? _setup.t(
                            "Проверьте данные и запишитесь",
                            _setup.options
                          )
                        : _setup.t("Запись на приём к врачу", _setup.options)
                    ) +
                    "\n    "
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _setup.isUserStaff && !_setup.isMobile
        ? _c(
            "div",
            {
              staticClass:
                "appointment-title__appointment-type text-body-1 text--text ml-5",
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_setup.appointmentDataStore.appointmentTypeLabel) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.isMobile
        ? _c(
            VBtn,
            {
              staticClass: "ml-4",
              attrs: { icon: "", text: "", depressed: "", color: "text" },
              on: { click: _setup.handleClickClose },
            },
            [
              _c(VIcon, [
                _vm._v("\n      ui-icon-close-not-a-circle\n    "),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }